const initialState = {
  generatedReports: [],
};

export const calibrationReducer = (state = initialState, action) => {
  switch (action.type) {
    case "addCalReport":
      return {
        ...state,
        generatedReports: [...state.generatedReports, action.payload],
      };
    case "deleteCalReport":
      return {
        ...state,
        generatedReports: state.generatedReports.filter(
          (r) => r.id !== action.payload,
        ),
      };
    default:
      return state;
  }
};
